export * from "./equipamentoReducer";
export * from "./equipamentoActions";
